import { render, staticRenderFns } from "./suggestionsListsGrid.vue.html?vue&type=template&id=0b463061&"
import script from "./suggestionsListsGrid.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListsGrid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports